import { createAsyncThunk } from "@reduxjs/toolkit";

import { getpdacalculatorReport, addpdacalculatorReport } from "../../apis/pdaCalculator";

export const addPdaCalculatorReportData = createAsyncThunk("pdaCalculator/addpdaCalculator", async(
    { notification_intro, jobId, port_callings_id, checked, email_list}: { notification_intro: string; jobId: string; port_callings_id: string; checked:boolean, email_list:string },
  { rejectWithValue })=>{
    try {
        // Call the correct API function with optional parameters
        const response = await addpdacalculatorReport({
            notification_intro,
              jobId,
              port_callings_id,
              checked,
              email_list
        });
        return response;
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const getPdaCalculatorReportData = createAsyncThunk(
  "getpdaCalculator/getpdaCalculatorReport",
  async (
    { notification_intro, jobId, port_callings_id, checked}: { notification_intro: string; jobId: string; port_callings_id: string; checked:boolean },
    { rejectWithValue }
  ) => {
    try {
      // Pass the parameters to the API function
      const response = await getpdacalculatorReport({
          notification_intro,
            jobId,
            port_callings_id,
            checked,
      });
      return response;
    } catch (error: any) {
      console.error("Error fetching port call notification:", error);
      return rejectWithValue(error.message || "Failed to fetch port call notification");
    }
  }
);